import mateoPng from "../assets/images/Mateo.png";
import toniPng from "../assets/images/Toni.png";
import nadiaPng from "../assets/images/Nadia.png";
import butterbeanPng from "../assets/images/Butterbean.png";
import toniFull from "../assets/images/Toni-full.png";
import nadiaFull from "../assets/images/Nadia-full.png";
import mateoFull from "../assets/images/Mateo-full.png";
import { getCharacterDescriptions } from "../services/audioDescription.js";

const MATEO = "Mateo";
const BUTTERBEAN = "Butterbean";
const TONI = "Toni";
const NADIA = "Nadia";

// eslint-disable-next-line no-unused-vars
const VALID_NAMES = /** @type {const} */ ([MATEO, BUTTERBEAN, TONI, NADIA]);

export class Persona {
  /**
   * @constructor
   * @param {Object} args
   * @param {typeof VALID_NAMES[number] | "User"} args.name
   */
  constructor({ name }) {
    this._name = name;
  }

  get avatar() {
    switch (this.name) {
      case MATEO:
        return mateoPng;
      case BUTTERBEAN:
        return butterbeanPng;
      case TONI:
        return toniPng;
      case NADIA:
        return nadiaPng;
      default:
        return "";
    }
  }

  /**
   * @returns {typeof VALID_NAMES[number] | "User"}
   */
  get name() {
    return this._name;
  }

  set name(newName) {
    this._name = newName;
  }

  get img() {
    switch (this.name) {
      case TONI:
        return toniFull;
      case NADIA:
        return nadiaFull;
      case MATEO:
        return mateoFull;
      default:
        return "";
    }
  }

  get color() {
    switch (this.name) {
      case TONI:
        return "#0064AA";
      case NADIA:
        return "#FFD84C";
      case MATEO:
        return "#00883B";
      default:
        return "#FFF";
    }
  }

  /**
   * @param {{[key: string]: string | null}} strings
   */
  getDescription(strings) {
    const characterDescriptions = getCharacterDescriptions(strings);
    if (this.name in characterDescriptions) {
      // @ts-ignore
      return characterDescriptions[this.name].main;
    }
    return "";
  }

  /**
   * @param {{[key: string]: string | null}} strings
   * @returns {string}
   */
  getShortDescription(strings) {
    const characterDescriptions = getCharacterDescriptions(strings);
    if (this.name in characterDescriptions) {
      // @ts-ignore
      return characterDescriptions[this.name].short;
    }
    return "";
  }
}
